import type { User } from '../types/commons';

export type Level = 'info' | 'warning' | 'error';

export type ErrorNotifier = {
  notify: (error: Error, level?: Level) => void;
  setUser: (user: User | null) => void;
};

const errorNotifiers: ErrorNotifier[] = [];

export const registerErrorNotifier = (errorNotifier: ErrorNotifier) => {
  errorNotifiers.push(errorNotifier);
};

export const errorNotifier: ErrorNotifier = {
  notify: (error: Error, level: Level = 'error') => {
    errorNotifiers.map((notifier) => notifier.notify(error, level));
  },
  setUser: (user) => {
    errorNotifiers.map((u) => u.setUser(user));
  },
};
